import ActiveRecord from './active_record/base'

class MailSubscription extends ActiveRecord {
	static tableName = 'mailSubscriptions'
}

export default MailSubscription
